import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from "@angular/material/dialog";

import { ConfirmationCheck } from "../../../services/confirmation-dialog";

@Component({
  selector: "dialog-message",
  templateUrl: "dialog-message.html",
  styleUrls: ["dialog-message.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, MatDialogClose, TranslatePipe, FormsModule],
})
export class DialogMessageComponent {
  protected data = inject<{ title: string; message: string; isConfirm: boolean; checks?: ConfirmationCheck[] }>(
    MAT_DIALOG_DATA,
  );
  protected dialogRef = inject(MatDialogRef<DialogMessageComponent>);

  public emitter = output<boolean>();

  protected title = computed(() => this.data.title);
  protected message = computed(() => this.data.message);
  protected isConfirm = computed(() => this.data.isConfirm ?? false);
  protected checkboxList = signal(
    this.data.checks?.map((check) => ({ ...check, value: check.initialValue ?? false })) ?? [],
  );

  addCheckbox(name: string, label: string, initialValue?: boolean) {
    this.checkboxList.update((cur) => [...cur, { name, label, value: initialValue ?? false }]);
  }

  getCheckboxResults() {
    return this.checkboxList().map((check) => ({ name: check.name, value: check.value }));
  }

  closeDialog() {
    this.dialogRef.close();
  }

  emitPositive() {
    this.emitter.emit(true);
    this.closeDialog();
  }

  emitNegative() {
    this.emitter.emit(false);
    this.closeDialog();
  }
}
